<div>
  <h2>Session Settings</h2>
  <hr class="hr-line mt-lg">
  <div class="row form-group">
    <div class="col-sm-3 col-xs-12">
      <label>Session Timeout:</label>
      <select
        class="form-control"
        id="sessionExpiry"
        name="sessionExpiry"
        [(ngModel)]="currentExpirySetting"
        (change)="onSettingChange()"
        [disabled]="!currentExpirySetting">
        <option
          *ngFor="let option of expiryOptions"
          [ngValue]="option.backendValue">
          {{ option.displayValue }}
        </option>
      </select>
      <p *ngIf="!currentExpirySetting">Loading current setting...</p>
    </div>
  </div>
  <hr class="hr-line mt-lg">
</div>
